import { observer } from "mobx-react";
import CommonStrata from "../../Models/Definition/CommonStrata";
import Styles from "./parameter-editors.scss";
import { jsx as _jsx } from "react/jsx-runtime";
const DateTimeParameterEditor = observer(_ref => {
  var _parameter$value;
  let {
    parameter
  } = _ref;
  const style = (parameter === null || parameter === void 0 ? void 0 : parameter.value) !== undefined ? Styles.field : Styles.fieldDatePlaceholder;
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx("input", {
      className: style,
      type: "datetime-local",
      value: (_parameter$value = parameter.value) !== null && _parameter$value !== void 0 ? _parameter$value : "",
      onChange: e => parameter.setValue(CommonStrata.user, e.target.value)
    })
  });
});
export default DateTimeParameterEditor;